import React, { useState, useEffect, useRef, useContext } from 'react';
import styles from 'components/layout_and_quote_builder/_style.module.scss';
import LayoutNavSubSection from 'components/layout_and_quote_builder/LayoutNavSubSection.jsx'
import ChooseLayoutDimensions from 'components/layout_and_quote_builder/options/ChooseLayoutDimensions.jsx';

const LayoutNavSubSectionWrapped = ( {sub_section, index, activeRedraws, setActiveRedraws, activeTab, items, setItems, requiredPartsMissingError}) => {
  return "retireddd.."

  const [selectedBtn, setSelectedBtn] = useState('material')
  const [materialLayoutDimensions, setMaterialLayoutDimensions] = useState( { } )
  const [printingLayoutDimensions, setPrintingLayoutDimensions] = useState( { } )
  const [diecuttingLayoutDimensions, setDiecuttingLayoutDimensions] = useState( { } )

  const material_view = () => {
    return (
      <div className={`${styles.nav_section_wrapped_material}`}>
      <div className={`col-lg-3`}> &nbsp; </div>
      <div className={`${styles.nav_section_wrapped_material} col-lg-6`}>
        <ChooseLayoutDimensions
          title="Malzeme Tabaka Boyutlari"
          item={items[0]}
          hideMargins={true}
          hideCustom={true}
          defaultValues={materialLayoutDimensions}
          publicSetter={setMaterialLayoutDimensions}
          />
        <br />
        materialLayoutDimensions = { materialLayoutDimensions['layout_dimension_id'] }
      </div>
      <div className={`col-lg-3`}> &nbsp; </div>
    </div>
    )
  }

  const diecutting_view = () => {
    return (
      <>
      <div className={`${styles.nav_section_wrapped_diecutting}`}>

        <LayoutNavSubSection
          sub_section={sub_section}
          index={index}
          activeTab={activeTab}
          activeRedraws={activeRedraws}
          setActiveRedraws={setActiveRedraws}
          items={items}
          setItems={setItems}
          requiredPartsMissingError={requiredPartsMissingError}

          layoutDimensionType="diecutting"
          layoutDimensionTitle="Bicak Tabaka Boyutlari"
          materialLayoutDimensionId={materialLayoutDimensions['layout_dimension_id']}
          layoutDimensionDefaultValues={diecuttingLayoutDimensions}
          layoutDimensionPublicSetter={setDiecuttingLayoutDimensions}
          layoutDimensionSmallerSubSetOf={materialLayoutDimensions['layout_dimension_id']}
        />

      </div>
    </>
      )
  }

  const printing_view = () => {
    return (<> <div className={`${styles.nav_section_wrapped_material} col-lg-1`}> </div>
      <div className={`${styles.nav_section_wrapped_material} col-lg-10`}>
        <p> Prnting Sheet size: </p>
        <ChooseLayoutDimensions item={items[0]} hideCustom={true} defaultValues={printingLayoutDimensions} publicSetter={setPrintingLayoutDimensions} />
        <br />
        printingLayoutDimensions = { printingLayoutDimensions['layout_dimension_id'] }
      </div> </>
    )
  }

  return (
    <div key={`all_body_cont_${index}`} className={`${styles.nav_sub_section_wrapped} ${index != activeTab && 'hidden'}`}>

      <div className={`${styles.nav_section_wrapped_left} ${styles.float_left}`}>
        <div className={`${styles.sub_section_btn} ${selectedBtn == 'material' ? styles.sub_section_btn_active : '' } `} onClick={() => setSelectedBtn(() => 'material') }> Material </div> <br />
        <div className={`${styles.sub_section_btn} ${selectedBtn == 'diecutting' ? styles.sub_section_btn_active : '' } `} onClick={() => setSelectedBtn(() => 'diecutting') }> Die Cutting </div> <br />
        <div className={`${styles.sub_section_btn} ${selectedBtn == 'printing' ? styles.sub_section_btn_active : '' } `} onClick={() => setSelectedBtn(() => 'printing') }> Printing </div> <br />
      </div>

      <div className={`${styles.nav_section_wrapped_right} ${styles.float_right}`}>
        { selectedBtn == 'material' &&  material_view() }
        { selectedBtn == 'diecutting' &&  diecutting_view() }
        { selectedBtn == 'printing' &&  printing_view() }
       </div>
    </div>
    )
}

export default LayoutNavSubSectionWrapped;
